<template>
    <dtunes-modal :dialog="dialog" @openModal = "dialog = true" @closeModal = "dialog = false">
        <template v-slot:button> 
            <v-icon>mdi-plus</v-icon>
            Add Notification 
        </template>
        <template v-slot:content>
            <v-card class="pad-10">
                <v-card-title class="d-flex justify-center">
                    <p class="text-center"><b>Add New Notification</b></p>
                </v-card-title>
                <v-card-text>
                    <label for="">Title</label>
                    <v-text-field color="orange" placeholder="Notification title" v-model="title" outlined ></v-text-field>
                    <label for="">Desription</label>
                    <v-textarea color="orange" placeholder="Notification details" v-model="details" outlined ></v-textarea>
                    <label for="">Publication Date</label>
                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="computedDateFormatted"
                                outlined
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="date" no-title color="primary" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                    <label for="">Publication Time</label>
                    <v-menu
                        ref="menu"
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="time"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="time"
                            outlined
                            prepend-inner-icon="mdi-clock-time-four-outline"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-time-picker
                        v-if="menu1"
                        v-model="time"
                        full-width
                        @click:minute="$refs.menu.save(time)"
                        ></v-time-picker>
                    </v-menu>
                    <default-button :loading="loading" :disabled="!isComplete" @click="addNotification()">
                        Add Notification
                        <v-icon color="white">
                            mdi-bell
                        </v-icon>
                    </default-button>
                </v-card-text>
            </v-card>
        </template>
    </dtunes-modal>
</template>

<script>
import DtunesModal from "@/components/dtunes-modal.vue";
import DefaultButton from '@/components/Buttons/default-button.vue';
import { AppService } from "@/services";

export default {
    data: vm => ({
        loading: false,
        time : null,    
        menu1:false,
        dialog:false,
        menu2: false,
        title:'',
        details:'',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
    }),
    computed:{
        isComplete() {
            return this.title && this.details;
        },
        computedDateFormatted () {
            return this.formatDate(this.date)
        },
    },
    methods:{
        formatDate (date) {   
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${month}-${day}-${year}`
        },
        
        async sendNotificationRequest(){
            this.loading = true;
            let payload = {
                title : this.title,
                details : this.details,
                publicationDate:`${this.computedDateFormatted} ${this.time}`
            }
            await AppService.createNotificaions(payload);
            this.loading = false;
            this.dialog = false;
            this.$emit('reload');
        },

        async addNotification(){
            try {
                await this.sendNotificationRequest();
                this.$store.dispatch('toast', {
                    message: ` ${this.title} Notification created`,
                    variant: 'success'
                });
            } catch (error) {
                this.loading = false
            }
        }
    },
    components: {
        DtunesModal,
        DefaultButton
    },
    watch:{
        date (val) {
            this.dateFormatted = this.formatDate(val)
        },
    }
};
</script>